/* eslint react/prop-types: 0, react/display-name: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import { connect } from 'react-redux';
import get from 'lodash.get';
import CartLoading from './CartLoading';
import CartError from './CartError';
import { loadLocalCart } from './actions/localCartActions';
import { CartRefetchContainer } from './CartRefetchContainer';

class CartRenderer extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.dispatch(loadLocalCart());
    }
    render() {
        const { relayEnvironment, localCartItems } = this.props;
        const userId = getBuyerId(document.cookie) || '';
        const hasUserId = !!userId;
        const userIds = hasUserId ? [userId] : [];
        const localItemIds = localCartItems.map(({ id }) => id);
        return (
            <QueryRenderer
                environment={relayEnvironment}
                query={graphql`
                    query CartRendererQuery(
                        $userId: String!
                        $userIds: [String]!
                        $hasUserId: Boolean!
                        $localItemIds: [String]
                        $fetchLocalItems: Boolean!
                        $loadPortfolioData: Boolean!
                    ) {
                        viewer {
                            ...CartRefetchContainer_viewer
                        }
                    }
                `}
                variables={{
                    userId,
                    userIds,
                    hasUserId,
                    localItemIds,
                    fetchLocalItems: Boolean(!hasUserId && localItemIds.length),
                    loadPortfolioData: !!userId,
                }}
                render={({ error, props }) => {
                    if (error) {
                        return <CartError />;
                    } else if (props) {
                        return (
                            <CartRefetchContainer
                                localCartItems={localCartItems}
                                viewer={props.viewer}
                            />
                        );
                    } else {
                        return <CartLoading isStaticLoading />;
                    }
                }}
            />
        );
    }
}

CartRenderer.propTypes = {
    relayEnvironment: PropTypes.object.isRequired,
    // redux
    localCartItems: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect(state => {
    const localCartItems = get(state, 'cart.items') || [];

    return {
        localCartItems,
    };
})(CartRenderer);
